/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React from 'react';

interface ProductDescriptionProps {
  heading: string;
  description?: { html: string };
}

const ProductDescription = (props: ProductDescriptionProps) => {
  const { heading, description } = props;

  return <div className={`product-description-container ${heading ? 'border-bottom' : ''} pb-5 mt-5`}>
    <h2 className='mb-4 strong'>{heading}</h2>
    <div
      className='body'
      dangerouslySetInnerHTML={{ __html: description?.html ?? '' }}
    />
  </div>
}

export default ProductDescription;
